export const BLACK = '#000000';
export const WHITE = '#FFFFFF';

export const PRIMARY_GRADIENT =
  'linear-gradient(108deg, #FF512F 0%, #FF512F 41%, #DD2476 100%)';
